import { themeBalham } from 'ag-grid-community';
import { colorSchemeDark, colorSchemeLight } from 'ag-grid-community';

export const agGridThemes = {
  dark: themeBalham
  .withPart(colorSchemeDark)
  .withParams({
    backgroundColor: '#161827',
    foregroundColor: '#dedede',
    accentColor: '#429E9B',//'#c6c6c6',
    headerTextColor: '#c7c7c7',
    headerFontSize: 14,
    headerBackgroundColor: '#0b0c14',
    oddRowBackgroundColor: 'rgba(255, 255, 255, 0.03)',
    spacing: '4px',
    wrapperBorderRadius: 2,
    fontSize: 14,
    wrapperBorder: true,
    headerRowBorder: false,
    rowBorder: false
  })
}